import { StatusChange } from './status-change.modal';

export class RoleModal extends StatusChange {
      public  userId:string;
      public appId:string;
      public selectedRoles:Array<string>;
      public clientId:string;


}
